export const PROPERTY_STATUS_ENUM = {
  Inactive: 'Inactive',
  Active: 'Active',
  Deactivated: 'Deactivated',
  Deleted: 'Deleted'
};

// export const PROPERTY_STEPS = {
//   PropertyInformation: 1,
//   ContactInformation: 2,
//   FeeSetup: 3,
//   PayoutDetails: 4,
//   UtilityConfiguration: 5,
//   UnitSetup: 6,
//   ConfirmProperty: 7,
// };

export const PROPERTY_STEPS = {
  PropertyInformation: 1,
  FeeSetup: 2,
  PayoutDetails: 3,
  UtilityConfiguration: 4,
  UnitSetup: 5,
  ConfirmProperty: 6
  // ContactInformation: 7,
};
export const DEMO_PROPERTY_STEPS = {
  PropertyInformation: 1,
  FeeSetup: 2,
  UtilityConfiguration: 3,
  UnitSetup: 4,
  ConfirmProperty: 5
};
export const APPFOLIO_PROPERTY_STEPS = {
  PropertyInformation: 0,
  UtilityConfiguration: 1,
  UnitSetup: 2,
  FeeSetup: 3,
  PayoutDetails: 4,
  ConfirmProperty: 5
};
export const BUILDING_CONTACT_TYPES = {
  building: 'Building',
  utility: 'Utility'
};